/* The Charm Lab — display-only currency switcher (22 Oct 2026).

   Shopify can only charge in other currencies through Shopify Payments, which
   is not available in Thailand, so checkout is always in THB. This switcher
   only changes how prices LOOK on the site: every "฿1,500" on the page is
   shown in the chosen currency using Shopify's daily exchange rates
   (/services/javascripts/currencies.js), with a note that checkout is in THB.

   The choice is remembered in this browser. Prices written later by other
   scripts (Charm Lab builder, bag, variant changes) are caught by a
   MutationObserver and converted too. Anything inside [data-cl-noconvert] is
   left alone. */
(function () {
  'use strict';

  var CODES = ['THB', 'USD', 'GBP', 'EUR', 'AUD', 'SGD', 'HKD', 'JPY', 'KRW', 'MYR', 'CNY', 'CAD'];
  var LABEL = { THB: '฿ THB', USD: '$ USD', GBP: '£ GBP', EUR: '€ EUR', AUD: 'A$ AUD', SGD: 'S$ SGD',
    HKD: 'HK$ HKD', JPY: '¥ JPY', KRW: '₩ KRW', MYR: 'RM MYR', CNY: '¥ CNY', CAD: 'C$ CAD' };
  var NO_DEC = { JPY: 1, KRW: 1 };
  var KEY = 'cl-currency';
  var TH = (document.documentElement.lang || '').indexOf('th') === 0;
  var T = TH
    ? { label: 'สกุลเงิน', note: function (c) { return 'ราคาที่แสดงเป็น ' + c + ' เป็นราคาโดยประมาณ ระบบจะเรียกเก็บเงินเป็นเงินบาท (THB) เมื่อชำระเงิน'; } }
    : { label: 'Currency', note: function (c) { return 'Prices in ' + c + ' are approximate. You will be charged in Thai baht (THB) at checkout.'; } };

  var RE = /฿\s?(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{1,2}))?/g;
  var current = 'THB';
  var rates = null;
  var seen = new Map(); /* text node -> { orig, shown } */

  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  function fmt(thb) {
    if (!rates || !rates[current] || !rates.THB) return null;
    var v = thb * rates.THB / rates[current];
    var d = NO_DEC[current] ? 0 : 2;
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: current, minimumFractionDigits: d, maximumFractionDigits: d }).format(v);
    } catch (e) {
      return current + ' ' + v.toFixed(d);
    }
  }

  function skip(node) {
    var p = node.parentNode;
    if (!p || p.nodeType !== 1) return true;
    var tag = p.nodeName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'NOSCRIPT') return true;
    /* option values (gift voucher amounts) stay in THB: they name the voucher, not a price */
    return !!(p.closest && p.closest('[data-cl-noconvert], .optbtn, option'));
  }

  function convertNode(node) {
    if (skip(node)) return;
    var rec = seen.get(node);
    var text = node.nodeValue;
    if (rec && text === rec.shown) return;          /* our own write */
    if (rec && text !== rec.shown) seen.delete(node); /* rewritten by another script */
    if (text.indexOf('฿') === -1) return;
    if (current === 'THB') return;
    var out = text.replace(RE, function (m, whole, dec) {
      var n = parseFloat(whole.replace(/,/g, '') + (dec ? '.' + dec : ''));
      return fmt(n) || m;
    });
    if (out !== text) {
      seen.set(node, { orig: text, shown: out });
      node.nodeValue = out;
    }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { convertNode(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, list = [];
    while ((n = w.nextNode())) if (n.nodeValue.indexOf('฿') !== -1) list.push(n);
    list.forEach(convertNode);
  }

  function restoreAll() {
    seen.forEach(function (rec, node) {
      if (node.nodeValue === rec.shown) node.nodeValue = rec.orig;
    });
    seen.clear();
  }

  /* ---------- notes ---------- */
  function updateNotes() {
    var show = current !== 'THB';
    var txt = T.note(current);
    var top = document.getElementById('cl-cur-note');
    if (show && !top) {
      top = document.createElement('div');
      top.id = 'cl-cur-note';
      top.className = 'cl-cur-note';
      top.setAttribute('data-cl-noconvert', '');
      var main = document.getElementById('MainContent');
      if (main) main.insertBefore(top, main.firstChild);
    }
    if (top) { if (top.hidden !== !show) top.hidden = !show; if (top.textContent !== txt) top.textContent = txt; }

    [].forEach.call(document.querySelectorAll('button[name="checkout"]'), function (b) {
      var p = b.previousElementSibling;
      var note = p && p.classList && p.classList.contains('cl-cur-note-sm') ? p : null;
      if (show && !note) {
        note = document.createElement('p');
        note.className = 'cl-cur-note-sm';
        note.setAttribute('data-cl-noconvert', '');
        b.parentNode.insertBefore(note, b);
      }
      if (note) { if (note.hidden !== !show) note.hidden = !show; if (note.textContent !== txt) note.textContent = txt; }
    });
  }

  /* ---------- selectors ---------- */
  function buildSelect(id, cls) {
    var s = document.createElement('select');
    s.id = id;
    s.className = cls;
    s.setAttribute('aria-label', T.label);
    s.setAttribute('data-cl-noconvert', '');
    CODES.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c;
      o.textContent = LABEL[c];
      s.appendChild(o);
    });
    s.value = current;
    s.addEventListener('change', function () { setCurrency(s.value); });
    return s;
  }

  function addHeaderSelect() {
    if (document.getElementById('HeaderCurrency')) return;
    var right = document.querySelector('.nav-right');
    if (!right) return;
    var s = buildSelect('HeaderCurrency', 'cur hide-sm');
    var lang = document.getElementById('HeaderLanguageForm');
    if (lang && lang.parentNode === right) right.insertBefore(s, lang.nextSibling);
    else right.insertBefore(s, right.firstChild);
  }

  function addMobileSelect() {
    var mob = document.getElementById('mobmenu');
    if (!mob || !mob.dataset.built || mob.querySelector('#MobCurrency')) return;
    var head = document.createElement('div');
    head.className = 'grp';
    head.textContent = T.label;
    var s = buildSelect('MobCurrency', 'cur cl-mobcur');
    mob.appendChild(head);
    mob.appendChild(s);
  }

  function syncSelects() {
    ['HeaderCurrency', 'MobCurrency'].forEach(function (id) {
      var s = document.getElementById(id);
      if (s) s.value = current;
    });
  }

  /* ---------- rates ---------- */
  function getRates(cb) {
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('cl-rates') || 'null'); } catch (e) {}
    if (cached && cached.THB) { rates = cached; cb(); return; }
    fetch('/services/javascripts/currencies.js', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (js) {
        var m = js.match(/rates:\s*(\{[^}]*\})/);
        if (!m) return;
        rates = JSON.parse(m[1]);
        try { sessionStorage.setItem('cl-rates', JSON.stringify(rates)); } catch (e) {}
        cb();
      })
      .catch(function () {});
  }

  function setCurrency(code) {
    if (CODES.indexOf(code) === -1) code = 'THB';
    var apply = function () {
      if (code !== 'THB' && (!rates || !rates[code])) code = 'THB';
      restoreAll();
      current = code;
      store(KEY, code === 'THB' ? null : code);
      syncSelects();
      walk(document.body);
      updateNotes();
    };
    if (code !== 'THB' && !rates) getRates(apply); else apply();
  }

  /* ---------- start ---------- */
  var style = document.createElement('style');
  style.textContent = '.cl-cur-note{background:var(--blush,#F5E6E1);color:var(--ink-soft,#5E4C43);font-size:.74rem;'
    + 'text-align:center;padding:8px 16px;border-bottom:1px solid var(--blush-mid,#EBD0C8)}'
    + '.cl-cur-note-sm{font-size:.72rem;color:var(--muted,#8C766A);margin:8px 0 6px;text-align:center}'
    + '.cl-mobcur{margin-top:4px;padding:10px 12px;font-size:.74rem;width:auto;align-self:flex-start}';
  document.head.appendChild(style);

  addHeaderSelect();
  var mob = document.getElementById('mobmenu');
  if (mob) new MutationObserver(addMobileSelect).observe(mob, { childList: true });
  addMobileSelect();

  var queue = [];
  var pending = false;
  new MutationObserver(function (muts) {
    if (current === 'THB') {
      /* still keep the checkout note in sync if a bag is rebuilt */
      return;
    }
    muts.forEach(function (m) {
      if (m.type === 'characterData') queue.push(m.target);
      else [].forEach.call(m.addedNodes, function (n) { queue.push(n); });
    });
    if (!pending) {
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var q = queue; queue = [];
        q.forEach(walk);
        updateNotes();
      });
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  var saved = load(KEY);
  if (saved && saved !== 'THB') setCurrency(saved);
})();